import { gql } from "@apollo/client";

export const TICKET_SEARCH_QUERY = gql`
  query TICKET_SEARCH_QUERY(
    $perPage: Int
    $page: Int
    $json: String
    $originatorId: ID!
  ) {
    searchTickets(
      perPage: $perPage
      page: $page
      json: $json
      originatorId: $originatorId
    ) {
      id
      incident {
        id
        incidentNumber
        ori {
          id
        }
        address {
          validAddressAlerts {
            id
            alertType {
              id
              name
              alertLevel
            }
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
        }
        personIncidentSpecifics {
          id
          bac
          sealed
          juvenile
          yoe
          person {
            id
            aliases {
              id
              target {
                id
                validPersonAlerts {
                  id
                  alertType {
                    id
                    name
                    alertLevel
                  }
                }
              }
            }
            validPersonAlerts {
              alertType {
                id
                name
                alertLevel
              }
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
            }
            personalAttribute {
              id
              firstName
              lastName
              homeAddress {
                id
                name
              }
              mailingAddress {
                id
                name
              }
            }
          }
        }
        officerIncidentSpecifics {
          id
          officer {
            id
            deptAttribute {
              id
              badge
              ori {
                id
                abbreviation
              }
            }
            personalAttribute {
              id
              lastName
              firstName
            }
          }
        }
        vehicleIncidentSpecifics {
          id
          vehicle {
            id
            vehicleMake {
              id
              nhtsaId
              name
            }
            vehicleModel {
              id
              nhtsaId
              name
            }
            vehiclePlate {
              id
              name
            }
          }
        }
      }
      ticketNumber
      issuedTo {
        aliases {
          id
          target {
            id
            validPersonAlerts {
              alertType {
                name
                alertLevel
              }
            }
          }
        }
        id
        validPersonAlerts {
          alertType {
            id
            name
            alertLevel
          }
          createdAt
          officer {
            deptAttribute {
              id
              badge
              ori {
                id
                abbreviation
              }
            }
            personalAttribute {
              id
              firstName
              lastName
            }
          }
        }
        personalAttribute {
          id
          lastName
          firstName
          middleName
        }
      }
      ticketViolationPrototype {
        id
        fullName
        name
        doNotSubmit
        ticketEntry {
          id
          name
        }
        ticketCategory {
          id
          name
        }
        ticketSubCategory {
          id
          name
        }
      }
    }
  }
`;
